import { Tooltip } from "@mui/material";
import TextFiledWithLabel from "./TextFieldWithLabel";

const ReadonlyTextField = ({label,name,value,tooltip = true,className = "readonly",...rest}) => {
  const field = (
    <TextFiledWithLabel
      label={label}
      name={name}
      value={value ?? ""}
      className={className}
      InputProps={{ readOnly: true }}
      {...rest}
    />
  );

  if (!tooltip) return field;

  return (
    <Tooltip title={value ?? ""} disableInteractive>
      <span>{field}</span>
    </Tooltip>
  );
};

export default ReadonlyTextField;
